import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage, buildSuccessMessage} from '../../common/util/errorUtils';

export const fetchInvoiceData = (invoice, providerId) => apiActionCreator({
  'endpoint': `/providers/${providerId}/invoices/${invoice}/imports`,
  'authenticated': true,
  'types': [
    ActionTypes.FETCHING_INVOICE_DATA,
    ActionTypes.FETCHED_INVOICE_DATA,
    [
      ActionTypes.FETCHED_INVOICE_DATA_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const cancelInvoice = (invoice, providerId) => apiActionCreator({
  'endpoint': `/providers/${providerId}/invoices/${invoice}/imports?action=cancellation`,
  'authenticated': true,
  'types': [
    ActionTypes.CANCELLING_INVOICE,
    [
      ActionTypes.CANCELLED_INVOICE,
      MessageActions.addMessageBoxInfo('Factura anulada satisfactoriamente'),
    ],
    [
      ActionTypes.CANCELLED_INVOICE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
});

export const createInvoice = (data, action) => {
  const actionQueryString = action === 'send' ? '?action=process' : '';
  
  return apiActionCreator({
    'endpoint': `/invoices/imports${actionQueryString}`,
    'authenticated': true,
    'types': [
      ActionTypes.CREATING_PROVIDER_INVOICES,
      [
        {
          'type': ActionTypes.CREATED_PROVIDER_INVOICES,
          'payload': action,
        },
        (response) => buildSuccessMessage(response, 'Factura creada satisfactoriamente'),
      ],
      [
        ActionTypes.CREATED_PROVIDER_INVOICES_FAILED,
        (error) => buildErrorMessage(error),
      ],
    ],
    'microservice': 'part',
    'method': 'POST',
    'contentType': 'application/json',
    'data': data,
  });
};

export const loadInitialData = () => ({
  'type': ActionTypes.LOAD_INITIAL_DATA,
});

export const saveExcelData = (list) => ({
  'type': ActionTypes.SAVE_EXCEL_DATA,
  'payload': list,
});

export const changeDetailsInInvoicesListPage = (value) => ({
  'type': ActionTypes.CHANGE_DETAILS_IN_INVOICES_LIST_PAGE,
  'payload': value,
});

export const changeDetailsInInvoicesListPageSize = (value) => ({
  'type': ActionTypes.CHANGE_DETAILS_IN_INVOICES_LIST_PAGE_SIZE,
  'payload': value,
});

export const addItemInLastPage = (lastPage) => ({
  'type': ActionTypes.ADD_ITEM_IN_LAST_PAGE,
  'payload': lastPage,
});

export const updateTotals = ({index, type, quantity, unitPrice, weight}) => ({
  'type': ActionTypes.UPDATE_TOTALS,
  'payload': {index, type, quantity, unitPrice, weight},
});
